/**
 * à la déconnexion, tout le localStorage est vidé à l'exception des clés commençant par ce préfixe :
 */
export const LOCAL_STORAGE_KEEP_ON_LOGOUT_PREFIX = 'keep_';
